import { useCookies } from 'react-cookie';
import { GEO_LOCATION_COOKIE_NAME } from 'shared/custom/constants/commonConstants';

export const useCurrentPhysicalStoreId = () => {
	const [cookies] = useCookies([GEO_LOCATION_COOKIE_NAME]);

	const physicalStoreId = cookies?.geoLocationHDP?.stLocId as string | null | undefined;

	return {
		physicalStoreId: physicalStoreId ?? null,
	};
};
